import axios from "axios";

export default function updateCompanyGroup({ uuid, name, selected }) {
  return new Promise((resolve, reject) => axios
    .put(`/account/system-admin/api/v1/company-group/${uuid}`, {
      name,
      items: selected
    })
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.message))
  );
}
